module.exports = __webpack_public_path__ + "894cf17bc4423b0677fde2621dca4dcc.png";